// client/plugins/arrowAutocompletion.ts
import { Plugin } from "prosemirror-state";
var arrowMappings = {
  "-->": "\u2192",
  "->": "\u2192",
  "==>": "\u21D2",
  "=>": "\u21D2",
  "<-->": "\u2194",
  "<->": "\u2194",
  "<==>": "\u21D4",
  "<=>": "\u21D4",
  "<--": "\u2190",
  "<-": "\u2190",
  "<==": "\u21D0",
  "<=": "\u21D0"
};
var arrowAutocompletion = new Plugin({
  state: {
    init() {
      return {
        lastReplacement: null
      };
    },
    apply(tr, value) {
      return {
        lastReplacement: tr.getMeta("arrowCompletion") || (tr.docChanged ? null : value.lastReplacement)
      };
    }
  },
  props: {
    handleKeyDown(view, event) {
      const pluginState = this.getState(view.state);
      if (!pluginState)
        throw new Error("Plugin state not found");
      if (event.key === "Backspace" && pluginState.lastReplacement) {
        const { pos, original } = pluginState.lastReplacement;
        const currentPos = view.state.selection.$head.pos;
        if (currentPos === pos + 2) {
          const tr = view.state.tr.delete(pos, currentPos).insertText(original).setMeta("arrowCompletion", null);
          view.dispatch(tr);
          return true;
        }
        return false;
      }
      if (event.key !== " ")
        return false;
      const { $head } = view.state.selection;
      const textBefore = $head.parent.textContent.slice(0, $head.parentOffset);
      for (let [arrow, replacement] of Object.entries(arrowMappings)) {
        replacement = `${replacement} `;
        if (textBefore.endsWith(arrow)) {
          const start = $head.pos - arrow.length;
          const tr = view.state.tr.delete(start, $head.pos).insertText(replacement).setMeta("arrowCompletion", {
            pos: start,
            original: arrow,
            replacement
          });
          view.dispatch(tr);
          return true;
        }
      }
      return false;
    }
  }
});
export {
  arrowAutocompletion
};
